
import { defineComponent, ref, provide, onMounted, computed, inject } from 'vue'
import { useRoute } from 'vue-router';
import { useStore } from "vuex";
//services
import eventService from "@/core/services/EventService";
import { errManager, dateParticipate } from "@/core/config/Tools";
import { useI18n } from "vue-i18n/index";
import MultimediaService from '@/core/services/MultimediaService'
//components
import btnBack from "@/components/buttons/btnBack.vue"
import VisorFile from "@/components/modals/general/VisorFile.vue";
import Attendees  from "@/views/attendees/AttendeesIndex.vue";
import CountDown from "@/components/widgets/mixed/dsCounter.vue"

export default defineComponent({
    name: "tournament-manager",
    components: { btnBack, VisorFile, Attendees, CountDown },
    setup() {
        const { t } = useI18n();
        const store = useStore();
        const route = useRoute();
        const loader = ref(false);
        const evento = ref<any>({})
        const { id } = route.params;
        const listDocs = ref<any[]>([]);
        const myCompany = inject<any>('gblCompany');
        const activity = ref<any>({});
        provide("evento", evento)
        //visor
        const open_dialog_view_file = ref(false)
        const urlFile = ref('')
        provide("urlFile", urlFile)
        provide("open_dialog_view_file", open_dialog_view_file)

        const company = computed(() => {
            return store.getters.currentUser.company
        })

        const getDocuments = async() => {
            loader.value = true
            await MultimediaService.getData({idevent: id, tabla: 'events'})
            .then((res)=>{
                listDocs.value = res.data
                loader.value = false
            }).catch(({response})=>{
                loader.value = false
                errManager(response)
            })
        }

        //detalle del evento
        const getDetails = async () => {
            loader.value = true
            await eventService.getOptions('events', `${id}/show`)
                .then((res) => {
                    loader.value = false;
                    evento.value = res.data;
                    activity.value = res.data?.activity ?? {};
                    if(evento.value?.iscompetition == "0"){
                        getDocuments();
                    }
                }).catch(({ response }) => {
                    loader.value = false
                    errManager(response)
                })
        };

        const openVisorFile = (ruta) => {
            urlFile.value = `${ruta}`
            open_dialog_view_file.value = true
        }

        onMounted(() => {
            getDetails();
        })

        return {
            t,
            id,
            loader,
            evento,
            myCompany,
            listDocs,
            activity,

            //events
            company,
            getDetails,
            dateParticipate,
            getDocuments,
            openVisorFile
        }
    },
})
